<div *ngIf="this.loadingService.loading$ | async" class="loader">
    <div class="spinner"></div>
</div>
